import React from "react";
import { termCondition } from "components/layout/footer/FooterData";
import { Link } from "gatsby";

import WhatsAppBubble from "assets/whatsapp_bubble.svg";

function FooterCopyRight({ whatsappBot }) {
  return (
    <>
      <div className="max-w-7xl mx-auto flex md:flex-row flex-col md:justify-between  lg:px-8 xl:px-0 justify-center items-center font-semibold md:px-12  gap-6  bg-black text-[#8F8F8F] text-sm py-6 flex-wrap font-opensans align-middle">
        <p className=" text-center">
          &copy; Copyright 2007-{new Date().getFullYear()} TOMEDES. All Rights
          Reserved.
        </p>
        <div className="col-start-3 col-end-4 pl-4 lg:pb-0 lg:pl-0 ">
          {termCondition?.map(({ link, url }, index) => (
            <React.Fragment key={index}>
              <Link
                to={url}
                className=" cursor-pointer hover:text-orange transition-colors duration-300"
              >
                {link}
              </Link>
              <span className="mx-4 last:hidden">|</span>
            </React.Fragment>
          ))}
        </div>
      </div>
      {whatsappBot ? (
        <a
          href="https://api.whatsapp.com/send?phone=972722200700"
          className="whatsapp-float"
          target="_blank"
        >
          <img src={WhatsAppBubble} alt="WhatsApp" className="w-14 h-14" />
        </a>
      ) : null}
    </>
  );
}
export default FooterCopyRight;
